import { render, staticRenderFns } from "./AddMember.vue?vue&type=template&id=edce0146&scoped=true&"
import script from "./AddMember.vue?vue&type=script&lang=js&"
export * from "./AddMember.vue?vue&type=script&lang=js&"
import style0 from "./AddMember.vue?vue&type=style&index=0&id=edce0146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edce0146",
  null
  
)

export default component.exports